import FormattedMessage from 'I18n/components/FormattedMessage';
import { HubspotCertificationIcon } from 'foundations-assets';
import { Text } from 'foundations-components/components/Text';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import ExternalPortalOnly from '../../accounts/components/ExternalPortalOnly';
import { jsx as _jsx } from "react/jsx-runtime";
const DEVREL_PORTAL_ID = 22047910;
export const ExternalLearningContentBanner = ({
  hubId
}) => {
  const isDevRelPortal = hubId === DEVREL_PORTAL_ID;
  return /*#__PURE__*/_jsx(ExternalPortalOnly, {
    portalId: hubId,
    children: /*#__PURE__*/_jsx(Tooltip, {
      cursor: "pointer",
      title: isDevRelPortal ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.externalContent.devRelTooltip"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.externalContent.externalCreatorTooltip"
      }),
      children: /*#__PURE__*/_jsx(MediaObject, {
        align: "center",
        itemLeft: /*#__PURE__*/_jsx(HubspotCertificationIcon, {
          color: "fill-accent-orange-default",
          size: "800"
        }),
        children: /*#__PURE__*/_jsx(Text, {
          textTransform: "uppercase",
          typography: "heading-50",
          children: isDevRelPortal ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.externalContent.devRelBanner"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.externalContent.externalCreatorBanner"
          })
        })
      })
    })
  });
};
export default ExternalLearningContentBanner;